import styles from './FilterHero.module.scss';
import { Heading } from 'ui/components/1-atoms/Heading/Heading';
import { Filter, FilterProps } from 'ui/components/2-molecules/Filter/Filter';
import { Container } from 'ui/components/4-habitats/Container/Container';

export interface FilterHeroProps {
	title: string;
	filter?: FilterProps;
}

export const FilterHero: React.FC<FilterHeroProps> = ({ title, filter }) => {
	return (
		<Container width="Standard">
			<div className={styles.FilterHero}>
				<Heading headingLevel="h1" style="xxl">
					{title}
				</Heading>
				{filter && <Filter {...filter}></Filter>}
			</div>
		</Container>
	);
};
